import Geometry from '@arcgis/core/geometry/Geometry';
import Polyline from '@arcgis/core/geometry/Polyline';
import Graphic from '@arcgis/core/Graphic';
import CIMSymbol from '@arcgis/core/symbols/CIMSymbol';
import SimpleFillSymbol from '@arcgis/core/symbols/SimpleFillSymbol';
import TextSymbol from '@arcgis/core/symbols/TextSymbol';
import JSON_areaFillSymbol from './symbols/areaFillSymbol.json';
import JSON_areaLineSymbol from './symbols/areaLineSymbol.json';
import JSON_areaTextSymbol from './symbols/areaTextSymbol.json';
import JSON_distanceLineSymbol from './symbols/distanceLineSymbol.json';
import JSON_distanceTextSymbol from './symbols/distanceTextSymbol.json';

import { Polygon } from 'cd-eft/utils/esriTypes';
import SimpleLineSymbol from '@arcgis/core/symbols/SimpleLineSymbol';

const __areaFillSymbol = SimpleFillSymbol.fromJSON(JSON_areaFillSymbol);
const __areaLineSymbol = SimpleLineSymbol.fromJSON(JSON_areaLineSymbol);
const __areaTextSymbol = TextSymbol.fromJSON(JSON_areaTextSymbol);
const __distanceLineSymbol = CIMSymbol.fromJSON(JSON_distanceLineSymbol);
const __distanceTextSymbol = TextSymbol.fromJSON(JSON_distanceTextSymbol);

export type MeasureInputType = 'measure-area' | 'measure-distance';
export type OnChangeMeasureToolHandler = (type: MeasureInputType) => void;
export class MeasureInputResult {
  readonly type: MeasureInputType;
  readonly geometry: Geometry;
  readonly lengthText?: string;
  readonly areaText?: string;
  readonly perimeterText?: string;

  constructor(
    type: MeasureInputType,
    geometry: Geometry,
    lengthText?: string,
    areaText?: string,
    perimeterText?: string
  ) {
    this.type = type;
    this.geometry = geometry;
    this.lengthText = lengthText;
    this.areaText = areaText;
    this.perimeterText = perimeterText;
  }

  generateGraphics(): Graphic[] {
    if (this.type === 'measure-distance') {
      const lineGraphic = new Graphic();
      lineGraphic.geometry = this.geometry;
      lineGraphic.symbol = __distanceLineSymbol;

      const textGraphic = new Graphic();
      textGraphic.geometry = this.geometry.extent.center.clone();
      const textSymbol = __distanceTextSymbol.clone();
      textSymbol.text = this.lengthText!;
      textGraphic.symbol = textSymbol;

      return [lineGraphic, textGraphic];
    } else if (this.type === 'measure-area') {
      const fillGraphic = new Graphic();
      fillGraphic.geometry = this.geometry;
      fillGraphic.symbol = __areaFillSymbol;

      const lineGraphic = new Graphic();
      const polygon = this.geometry as Polygon;
      const polyline = new Polyline({ spatialReference: this.geometry.spatialReference });
      polyline.paths = polygon.rings;
      lineGraphic.geometry = polyline;
      lineGraphic.symbol = __areaLineSymbol;

      const textGraphic = new Graphic();
      textGraphic.geometry = this.geometry.extent.center.clone();
      const textSymbol = __areaTextSymbol.clone();
      textSymbol.text = this.areaText!;
      textGraphic.symbol = textSymbol;

      return [fillGraphic, lineGraphic, textGraphic];
    } else {
      throw new Error('Unexpected value: type.');
    }
  }
}
